import {useProtectPlusContext} from '../ProtectPlus/ProtectPlusProvider'
import classNames from 'classnames'

export const LoadingShim = () => {
	const {state: {saleInProgress}} = useProtectPlusContext()
	return (
		<div
			className={classNames(
				"absolute bg-pulse-blue opacity-50 flex inset-0 items-center justify-center rounded-lg", {
					'invisible': !saleInProgress,
					'visible': saleInProgress,
					'z-40': saleInProgress
				})}>
			<div className="flex gap-2 opacity-100 z-50">
				<div className="w-5 h-5 rounded-full animate-bounce bg-white [animation-delay:0.3s]"></div>
				<div className="w-5 h-5 delay-75 rounded-full animate-bounce bg-white [animation-delay:0.15s]"></div>
				<div className="w-5 h-5 delay-150 rounded-full animate-bounce bg-white"></div>
			</div>
		</div>
	)
}
